App.OrdersMapOrderDetailedRoute = require '../../order/modal'
